import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Edit16, Trash16 } from '@makyoapp/makyo-icon/icon'
import { DeleteModal, MoreDropdown } from '@makyoapp/makyo-ui'

interface StorageFolderMoreDropdownProps {
  folderId: string
  folderName: string
  onRename: (id: string, name: string) => void
  onDelete: (id: string) => void
}

/**
 * @new
 */
export function StorageFolderMoreDropdown({
  folderId,
  folderName,
  onRename,
  onDelete,
}: StorageFolderMoreDropdownProps) {
  const { t } = useTranslation()
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteWithModal = async () => {
    setIsDeleting(true)

    try {
      // Call the original onDelete function
      await onDelete(folderId)

      // Close the modal
      setIsDeleteModalOpen(false)
    } catch (error) {
      console.error('Error deleting folder:', error)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <>
      <MoreDropdown placement='bottom-end' portalMenu menuClassName='text-m-m'>
        <MoreDropdown.MenuItem
          onClick={() => {
            onRename(folderId, folderName)
          }}
        >
          <Edit16 />
          <div>
            <Trans>Rename</Trans>
          </div>
        </MoreDropdown.MenuItem>
        <MoreDropdown.MenuItem
          className='red'
          onClick={() => {
            setIsDeleteModalOpen(true)
          }}
        >
          <Trash16 />
          <div>
            <Trans>Delete</Trans>
          </div>
        </MoreDropdown.MenuItem>
      </MoreDropdown>

      <DeleteModal
        show={isDeleteModalOpen}
        onHide={() => setIsDeleteModalOpen(false)}
        onSubmit={handleDeleteWithModal}
        onCancel={() => setIsDeleteModalOpen(false)}
        title={t('Delete Folder')}
        withCancel={true}
        cancelLabel={t('Cancel')}
        continueLabel={t('Yes, Delete')}
        isLoading={isDeleting}
        id='delete-single-folder-modal'
      >
        <p>{t('Are you sure you want to delete this folder and all its contents? This action cannot be undone.')}</p>
      </DeleteModal>
    </>
  )
}
